// TutorPanelTrigger — тактильная амбер-плитка «✦ Репетитор», открывающая
// глобальную side-panel AI-репетитора (useSidePanelStore kind="tutor").
// Единый источник кнопки: используется и в основном Topbar, и в шапках
// полноэкранных режимов (прохождение теста / карточек / голосовая сессия),
// чтобы из любого иммерсивного экрана можно было открыть репетитора с
// авто-подхватом контекста страницы (usePageContext) — не выходя из
// теста/карточек/голоса.
//
// Стиль см. styles.css → .ai-tile. i18n-ключи — namespace "layout" (как в Topbar).

import { Tooltip, TooltipContent, TooltipTrigger } from "@studyhub/ui/components/tooltip";
import { IconSparkles } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn";
import { useSidePanelStore } from "@/stores/side-panel";

export function TutorPanelTrigger({
	className,
	/** Только иконка — для узкой мобильной шапки и шапки воркспейса курса. */
	compact = false,
	/** Перед toggle (например закрыть шторку панели курса). */
	onBeforeToggle,
}: {
	className?: string;
	compact?: boolean;
	onBeforeToggle?: () => void;
}) {
	const { t } = useTranslation("layout");
	const isOpen = useSidePanelStore((s) => s.open && s.kind === "tutor");
	const toggle = useSidePanelStore((s) => s.toggle);
	const label = t("topbar.tutorLabel");
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<button
					type="button"
					onClick={() => {
						onBeforeToggle?.();
						toggle("tutor");
					}}
					aria-pressed={isOpen}
					className={cn(
						// Тактильная амбер-плитка «Картотека» — выделяется среди соседних
						// icon-кнопок шапки, сообщает: «AI здесь». См. styles.css → ai-tile.
						"ai-tile shrink-0 cursor-pointer rounded-[11px]",
						"inline-flex items-center justify-center",
						"text-[13px] font-semibold tracking-tight",
						compact ? "size-9 gap-0 px-0" : "h-9 gap-1.5 px-2.5",
						className,
					)}
					aria-label={t("topbar.tutorOpen")}
				>
					<IconSparkles size={16} stroke={1.75} className="shrink-0 fill-current" aria-hidden />
					{compact ? null : <span className="whitespace-nowrap">{label}</span>}
				</button>
			</TooltipTrigger>
			<TooltipContent side="bottom">{t("tooltips.tutor")}</TooltipContent>
		</Tooltip>
	);
}
